{
  "permissions": {
    "noPermission": "No tienes permiso para realizar esta acción",
    "viewOnly": "Solo ver"
  },
  "importFinished": "La importación ha finalizado",
  "switchLevel": "Cambie el nivel",
  "removeFilter": "Quitar el filtro",
  "styleByProperty": "Establezca las dimensiones del modelo utilizando los valores de propiedades de los elementos de la lista",
  "styleByPropertyTooltip": "Cuando está habilitada, el tamaño de los modelos de esta capa se determinará utilizando las dimensiones de la tabla de elementos de la lista. Para usar esta opción, los elementos de la lista deben contener columnas numéricas adicionales para «Anchura», «Longitud» y «Altura». Para obtener instrucciones detalladas, consulta nuestra",
  "styleByPropertyTooltipLink": "artículo de la base de conocimientos",
  "copy": {
    "copyTo": "Copiar a esta ubicación",
    "setTo": "Establecer una nueva ubicación",
    "tooltip": {
      "Map": "No se puede copiar a un plan",
      "Layer": "No se puede copiar en una capa"
    }
  },
  "digitalTwin": {
    "cameraModes": {
      "orbit": "Cámara orbital",
      "walk": "Camina",
      "fly": "Cámara Fly"
    }
  },
  "venue_bookmark": "Marcador de lugar",
  "venue_bookmark_form": {
    "save": "Guardar marcador",
    "name": "Nombre"
  },
  "venue_bookmark_view": {
    "bookmarks": "Marcadores",
    "delete_bookmark": "Eliminar marcador",
    "create_bookmark": "Crear un marcador desde la vista actual",
    "no_bookmarks": "Sin marcadores"
  },
  "venue_bookmark_no_venue_error": {
    "title": "No se puede crear el marcador",
    "message": "No puedes crear un marcador fuera de un lugar"
  },
  "venue_bookmark_creation_error": {
    "title": "No se puede crear un marcador",
    "message": "Se ha producido un error al crear el marcador. Vuelve a intentarlo más tarde."
  },
  "controls": {
    "toggle_street_names": "Nombres de calles y lugares",
    "disabled_terrain_sitemap_3d": "El terreno no se puede activar cuando hay un mapa del sitio en 3D a la vista",
    "disabled_3d_buildings_sitemap_3d": "Los edificios 3D no se pueden activar cuando hay un mapa del sitio 3D a la vista"
  },
  "modelPreview": {
    "front_view": "Vista frontal",
    "front_left_view": "Vista frontal izquierda",
    "capture_thumbnail": "Capturar miniatura",
    "preview_info_heading": "Compruebe la vista previa y ajuste el modelo si es necesario, asegurándose de que:",
    "preview_info_model_appears": "El modelo aparece en la vista previa tal y como se esperaba",
    "preview_info_centered": "El centro del modelo se cruza con la línea azul",
    "preview_info_orientation": "El modelo está orientado correctamente y mira hacia adelante cuando se ve de frente",
    "model_not_supported_error": "El modelo no es compatible. Pruebe con otro archivo o póngase en contacto con el servicio de asistencia."
  },
  "modelShowThumbnailUploader": "o sube un archivo",
  "not_support_custom_colour": "El modelo que has subido no admite colores personalizados. Para ver cómo habilitarlo, consulta el artículo ",
  "areaModel": {
    "distribution": {
      "title": "Distribución",
      "random": "Aleatorio",
      "uniform": "Uniforme"
    },
    "rotation": {
      "title": "Rotación",
      "random": "Aleatorio",
      "uniform": "Uniforme"
    }
  },
  "systemDataFieldNames": {
    "MapObjectName": "Nombre del objeto de mapa",
    "MapObjectArea": "Área",
    "MapObjectLength": "Longitud",
    "Coordinates": "Coordenadas",
    "RouteTime": "Tiempo de ruta",
    "QuantityOfModelsOnLine": "Cantidad",
    "QuantityOfModelsInArea": "Cantidad",
    "RotationZOfModelsInArea": "Rotación",
    "IconRotation": "Rotación",
    "ModelAltitude": "Altitud"
  },
  "dateTimeFilter": {
    "newObjectFilteredTitle": "Objeto de mapa filtrado",
    "newObjectFilteredBody": "El objeto de mapa recién creado se filtró según el filtro de fecha y hora"
  },
  "sitemapVersion": {
    "twoDimensional": "2D",
    "threeDimensional": "3D"
  },
  "shareMap": {
    "copyNotification": "El enlace del mapa compartido se ha copiado a tu portapapeles",
    "useDescription": "Los enlaces compartidos están diseñados para uso privado solo con personas específicas.",
    "warning": "No se permite la publicación pública ni la distribución masiva (por ejemplo, en sitios web, redes sociales o listas de correo). Para obtener más información sobre cómo compartir planes públicamente, póngase en contacto con support@iventis.com.",
    "customSharedLinkDuration": {
      "description": "Establece la duración del enlace:",
      "duration": {
        "ThreeDays": "3 días",
        "SevenDays": "7 días",
        "FourteenDays": "14 días",
        "ThirtyDays": "30 días"
      },
      "contactSupport": "Si necesita proporcionar acceso durante más de 30 días, póngase en contacto con support@iventis.com para analizar sus requisitos."
    }
  },
  "screenshot": {
    "take_screenshot": "Haz una captura de pantalla",
    "screenshot": "Captura",
    "copiedToClipboardToast": {
      "title": "Captura de pantalla copiada al portapapeles",
      "message": "Ahora puede pegarlo en otra aplicación"
    },
    "downloadedImageToast": {
      "title": "Captura descargada",
      "message": "Puedes encontrarla en tu carpeta de descargas"
    },
    "errorToast": {
      "title": "Algo salió mal",
      "message": "No se pudo tomar la captura de pantalla, inténtelo de nuevo"
    }
  },
  "style": {
    "altitude": "Altitud"
  }
}